import { browserAnalyticsConsent } from "@/lib/analytics-consent";
import { browserAnalyticsProperties } from "@/lib/telemetry-privacy";
import posthog from "posthog-js";
import { ANALYTICS_APP_ID } from "@/lib/analytics-constants";
import {
  getAnalyticsProductSurface,
  getAnalyticsRouteGroup,
  normalizeAnalyticsPath,
} from "@/lib/analytics-routes";
import { shouldDiscardBrowserAnalyticsEvent } from "@/lib/analytics-event-filter";

const posthogKey = process.env.NEXT_PUBLIC_POSTHOG_KEY;
const posthogHost = process.env.NEXT_PUBLIC_POSTHOG_HOST?.trim() || "https://us.i.posthog.com";
const appRelease = process.env.NEXT_PUBLIC_APP_RELEASE?.trim() || "unknown";

let initialized = false;
export function initializeBrowserAnalytics() {
if (!initialized && posthogKey && typeof window !== "undefined" && browserAnalyticsConsent() === "granted") {
  initialized = true;
  try {
    posthog.init(posthogKey, {
      api_host: posthogHost,
      capture_pageview: false,
      capture_pageleave: true,
      capture_exceptions: false,
      disable_session_recording: true,
      defaults: "2026-01-30",
      before_send: (event) => {
        if (!event || browserAnalyticsConsent() !== "granted") {
          return null;
        }
        if (shouldDiscardBrowserAnalyticsEvent(event)) {
          return null;
        }

        const currentHostname = window.location.hostname;
        const currentOrigin = window.location.origin;
        const currentPathname = normalizeAnalyticsPath(window.location.pathname);
        const productSurface = getAnalyticsProductSurface({
          pathname: currentPathname,
        });

        event.properties = browserAnalyticsProperties({
          ...(event.properties ?? {}),
          app_id: ANALYTICS_APP_ID,
          current_hostname: currentHostname,
          current_origin: currentOrigin,
          current_pathname: currentPathname,
          route_group: getAnalyticsRouteGroup(currentPathname),
          product_surface: productSurface,
          app_release: appRelease,
        });

        return event;
      },
      loaded: (instance) => {
        if (process.env.NODE_ENV === "development") {
          instance.debug();
          console.info("[posthog] initialized", {
            host: posthogHost,
            hasKey: Boolean(posthogKey),
          });
        }
      },
    });
  } catch {
    initialized = false;
    console.error("[posthog] initialization failed");
  }
} else if (typeof window !== "undefined" && process.env.NODE_ENV === "development") {
  console.warn("[posthog] missing NEXT_PUBLIC_POSTHOG_KEY");
}

}
initializeBrowserAnalytics();
